// Contenido de los 5 quizzes + pregunta router de entrada.
// Cada quiz tiene 7 preguntas y 3 zonas de resultado (verde/amarillo/rojo).
// `inverted: true` significa que un "Sí" SUMA puntos buenos (zona verde con muchos Sí).

export const ROUTER_OPTIONS = [
  {
    key: "athletes",
    icon: "🏃",
    title: "Soy deportista o entreno regularmente",
    subtitle: "Gym, running, crossfit, futbol, ciclismo, etc.",
  },
  {
    key: "over40",
    icon: "🌅",
    title: "Tengo 40+ años y siento cambios en mi cuerpo",
    subtitle: "Energía, recuperación, dolores nuevos…",
  },
  {
    key: "general",
    icon: "💚",
    title: "Solo quiero evaluar mi salud en general",
    subtitle: "Chequeo rápido sin enfoque específico.",
  },
  {
    key: "metabolic",
    icon: "❤️",
    title: "Tengo hipertensión y/o diabetes",
    subtitle: "O estoy en riesgo de tenerlas.",
  },
  {
    key: "prime",
    icon: "✨",
    title: "Mujer que quiere estar en su mejor versión",
    subtitle: "Piel, energía, fuerza, sensualidad, longevidad.",
  },
];

const TX = {
  WHATSAPP_BASE: "https://wa.me/",
};

export const QUIZZES = {
  athletes: {
    id: "athletes",
    badge: "Para Deportistas",
    title: "¿Tu cuerpo deportivo te está pasando factura?",
    hook: "Si entrenas 3+ veces por semana, este quiz te va a abrir los ojos. Responde con honestidad.",
    therapist: {
      name: "Fisioterapeuta Omar Aguilera",
      role: "Fisioterapeuta y Quiropráctico",
      service: "terapia_fisica",
      phoneWa: "527712141634",
      photo: "/img/team/therapist_1_quiro_fisio.png",
    },
    questions: [
      "¿Sientes molestias musculares que duran más de 48 horas después de entrenar?",
      "¿Has tenido la misma 'lesión chica' 3+ veces este año (tobillo, rodilla, hombro)?",
      "¿Truena tu cuello, rodillas u hombros al moverte?",
      "¿Tomas analgésicos antes o después de entrenar más de una vez por semana?",
      "¿Sientes la espalda baja 'rígida' al despertar?",
      "¿Has notado pérdida de fuerza o rango de movimiento en algún lado del cuerpo?",
      "¿Llevas más de 6 meses sin una valoración de un fisioterapeuta?",
    ],
    results: [
      {
        max: 2, color: "green", emoji: "🟢", label: "Bien encaminado",
        message: "Tu cuerpo está respondiendo bien al entrenamiento. Mantén el cuidado preventivo: una valoración cada 6 meses te mantiene lejos de lesiones.",
        cta: "Reserva una valoración preventiva",
      },
      {
        max: 4, color: "yellow", emoji: "🟡", label: "Tu cuerpo te está hablando",
        message: "Hay tensiones acumuladas. Una sesión de terapia física + manipulación quiropráctica te va a destrabar lo que llevas cargando.",
        cta: "Agenda con el Fisio Omar",
      },
      {
        max: 99, color: "red", emoji: "🔴", label: "Atención inmediata",
        message: "Estás a un mal movimiento de una lesión seria. Agenda valoración esta semana — más vale prevenir que rehabilitar.",
        cta: "Agenda valoración urgente",
      },
    ],
  },

  over40: {
    id: "over40",
    badge: "Para 40+",
    title: "¿Tienes 40+? Tu cuerpo está cambiando. ¿Qué tanto?",
    hook: "Después de los 40 el cuerpo no te perdona lo que antes sí. 7 preguntas para descubrir en qué zona estás.",
    therapist: {
      name: "Lic. Ismael Mendoza",
      role: "Médico Funcional · Ozonoterapia · Terapias Alternativas",
      service: "terapias_alternativas",
      phoneWa: "527711610609",
      photo: "/img/team/therapist_2_medicina_funcional.png",
    },
    questions: [
      "¿Te cuesta más trabajo levantarte del piso o subir escaleras que hace 5 años?",
      "¿Tu energía cae fuerte entre 3 y 5 de la tarde?",
      "¿Te dan dolores de espalda baja o cuello sin haber hecho nada raro?",
      "¿Duermes pero amaneces cansado/a?",
      "¿Has notado que las comidas 'se te quedan' más que antes (inflamación, peso)?",
      "¿Te late el corazón rápido o sientes 'vacíos' sin explicación?",
      "¿Notas la piel más opaca, con manchas o líneas que antes no tenías?",
    ],
    results: [
      {
        max: 2, color: "green", emoji: "🟢", label: "Vas como los grandes",
        message: "Mantén movimiento + nutrición + revisiones anuales. Tu cuerpo está respondiendo bien al paso del tiempo.",
        cta: "Reserva chequeo anual de mantenimiento",
      },
      {
        max: 4, color: "yellow", emoji: "🟡", label: "Tu cuerpo pide upgrade",
        message: "Es momento de combinar medicina funcional + terapia física + chequeo estético. No es vanidad, es prevención inteligente.",
        cta: "Agenda valoración integral",
      },
      {
        max: 99, color: "red", emoji: "🔴", label: "Tu sistema está pidiendo SOS",
        message: "Tu cuerpo está acumulando 'deuda' biológica. Una valoración integral de medicina funcional te puede cambiar la jugada.",
        cta: "Agenda valoración con el Lic. Mendoza",
      },
    ],
  },

  general: {
    id: "general",
    badge: "Chequeo General",
    title: "Tu salud en 60 segundos",
    hook: "Lo que tu cuerpo te dice en 7 preguntas. Cero ciencia compleja. Solo honestidad.",
    therapist: {
      name: "Fisioterapeuta Omar Aguilera",
      role: "Fisioterapeuta y Quiropráctico",
      service: "consulta_general",
      phoneWa: "527712141634",
      photo: "/img/team/therapist_1_quiro_fisio.png",
    },
    questions: [
      "¿Duermes menos de 7 horas la mayoría de las noches?",
      "¿Pasas más de 6 horas al día sentado/a?",
      "¿Te das cuenta de que estás tenso/a (cuello, mandíbula, hombros) varias veces al día?",
      "¿Tomas refresco, comida procesada o 'comida chatarra' más de 3 veces por semana?",
      "¿Hace cuánto que NO tomas 2 litros de agua en un solo día?",
      "¿Tienes dolores recurrentes (cabeza, espalda, articulaciones) que ya 'normalizaste'?",
      "¿Tu última valoración profesional fue hace más de 12 meses?",
    ],
    results: [
      {
        max: 2, color: "green", emoji: "🟢", label: "Top tier",
        message: "Eres de los pocos que se cuida bien. Date una sesión anual de mantenimiento y sigue con tus hábitos.",
        cta: "Reserva sesión anual de mantenimiento",
      },
      {
        max: 4, color: "yellow", emoji: "🟡", label: "Vas bien, pero hay fugas",
        message: "Pequeños ajustes (hidratación, movimiento, una sesión quiropráctica) te van a cambiar la jugada.",
        cta: "Agenda valoración integral",
      },
      {
        max: 99, color: "red", emoji: "🔴", label: "Tu cuerpo está en 'deuda'",
        message: "Tarde o temprano cobra factura. Vale agendar valoración antes de que sea reactiva — todavía estás a tiempo.",
        cta: "Agenda valoración esta semana",
      },
    ],
  },

  metabolic: {
    id: "metabolic",
    badge: "Hipertensión y Diabetes",
    title: "¿Qué tan bien estás controlando tu presión o glucosa?",
    hook: "Si tu doctor te dijo 'cuídate la presión/azúcar', este quiz te aterriza dónde estás parado/a. 7 preguntas honestas.",
    inverted: true, // Un "Sí" aquí es BUENO (suma puntos a favor)
    therapist: {
      name: "Lic. Ismael Mendoza",
      role: "Médico Funcional · Ozonoterapia · Terapias Alternativas",
      service: "terapias_alternativas",
      phoneWa: "527711610609",
      photo: "/img/team/therapist_2_medicina_funcional.png",
    },
    questions: [
      "¿Te tomas tus medicamentos siempre a la misma hora?",
      "¿Mides tu presión o glucosa al menos 1 vez por semana?",
      "¿Caminas, nadas o haces movimiento mínimo 4 días a la semana?",
      "¿Has reducido o eliminado refresco, jugos y pan blanco?",
      "¿Manejas el estrés con algo concreto (meditación, terapia, hobby)?",
      "¿Duermes 7+ horas seguidas la mayoría de las noches?",
      "¿Has hecho valoración funcional integral (no solo análisis de sangre) en los últimos 12 meses?",
    ],
    results: [
      {
        max: 2, color: "red", emoji: "🔴", label: "Territorio de alerta",
        message: "Tu cuerpo está pidiendo atención urgente. Medicina funcional + ozonoterapia te pueden ayudar a complementar tu tratamiento médico.",
        cta: "Agenda valoración funcional urgente",
      },
      {
        max: 4, color: "yellow", emoji: "🟡", label: "Hay focos rojos",
        message: "Vas en el camino, pero hay áreas críticas. Con ajustes de estilo de vida + ozonoterapia puedes reducir gradualmente tu medicación.",
        cta: "Agenda valoración funcional",
      },
      {
        max: 99, color: "green", emoji: "🟢", label: "Eres modelo a seguir",
        message: "Sigue con tu rutina. Una sesión de ozonoterapia o terapia neural cada 3 meses te ayuda a mantenerte así.",
        cta: "Reserva sesión de mantenimiento",
      },
    ],
  },

  prime: {
    id: "prime",
    badge: "Mujeres en su Prime",
    title: "¿Estás en tu PRIME o todavía no llegas?",
    hook: "Tu prime no es una edad, es una versión de ti. Responde 7 preguntas y descubre qué tan cerca estás.",
    inverted: true, // Más Sí = mejor zona
    therapist: {
      name: "Lic. Anabel Mendoza",
      role: "Cosmiatra · Estética facial y corporal",
      service: "estetica",
      phoneWa: "527711290073",
      photo: "/img/team/therapist_3_estetica.png",
    },
    questions: [
      "¿Te miras al espejo y te gusta lo que ves la mayoría de los días?",
      "¿Tu piel está luminosa, sin manchas evidentes y bien hidratada?",
      "¿Tienes energía estable durante el día (sin altibajos brutales)?",
      "¿Tu peso se ha mantenido estable los últimos 6 meses?",
      "¿Te sientes fuerte: cargar bolsas, subir escaleras, jugar con niños sin agitarte?",
      "¿Disfrutas tu vida sexual / sensación de feminidad sin incomodidad?",
      "¿Te dedicas tiempo a ti (rutina facial, ejercicio, masaje, terapia) al menos 1 vez por semana?",
    ],
    results: [
      {
        max: 2, color: "red", emoji: "🌱", label: "Empezar es la decisión más valiente",
        message: "Tu prime empieza el día que decides empezar. Un plan integral (facial + medicina funcional + terapia física) te transforma en 6-12 semanas.",
        cta: "Agenda valoración prime con Anabel",
      },
      {
        max: 5, color: "yellow", emoji: "⭐", label: "A un upgrade de tu prime",
        message: "Estás cerca. Combinación perfecta: facial profesional + ozonoterapia = transformación visible en 6 semanas.",
        cta: "Reserva tu plan upgrade",
      },
      {
        max: 99, color: "green", emoji: "💎", label: "PRIME total",
        message: "Eres referencia. Mantén con tratamientos de longevidad: hidrafacial, lifting facial natural, masajes anti-edad.",
        cta: "Reserva sesión de longevidad",
      },
    ],
  },
};

export function evaluateQuiz(quiz, answers) {
  const yesCount = answers.filter(Boolean).length;
  for (const tier of quiz.results) {
    if (yesCount <= tier.max) return { ...tier, score: yesCount };
  }
  return { ...quiz.results[quiz.results.length - 1], score: yesCount };
}

export function buildWhatsAppLink(quiz, result) {
  const msg =
    `Hola, hice el quiz "${quiz.title}" en la página de TerafiQuiro ` +
    `y mi resultado fue "${result.label}" (${result.score}/7 puntos). ` +
    `Quiero agendar una valoración. ¿Me puedes ayudar?`;
  return TX.WHATSAPP_BASE + quiz.therapist.phoneWa + "?text=" + encodeURIComponent(msg);
}
